import type { LibraryContext } from "@/native-shell/library";

/** Covers both browser and native library calls made by this app origin. */
export async function withOutingDownloadLock<T>(context: LibraryContext, id: string, work: () => Promise<T>, download = false): Promise<T> {
  if (navigator.locks) return navigator.locks.request(`peakwave-outing-download:${context.owner}:${id}`, work);
  // New downloads fail closed without cross-tab coordination. Idempotent
  // removals still work, including copies saved by an earlier app version.
  if (download) throw new Error("This browser cannot safely coordinate outing downloads. Update your browser or app, then retry.");
  return work();
}
